import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DismissingDarkAlert } from "../../../../Constant";
import { DISMISSING_DARK_DATA } from "../../../../Data/UiKit/Alert";
import { Alerts, Btn, P } from "../../../../AbstractElements";
import { Heart } from "react-feather";

const DismissingDarkAlerts = () => {
  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);

  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={DismissingDarkAlert} span={DISMISSING_DARK_DATA} />
        <CardBody>
          <Alerts fade color="secondary" isOpen={visible} className="alert-dismissible">
            <Heart />
            <P>Check your update! You should check in on some of those fields below.</P>
            <Btn className="btn-close" onClick={onDismiss}></Btn>
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DismissingDarkAlerts;
